export default __webpack_public_path__ + "static/media/fire_icon128.0d27bd3e.png";